import { Grid, Icon } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { IFilteringViewModel, ITableData } from "../../../_common/interface/table";
import { PrimaryButton } from "../../../_components/button/primary.button";
import { CommonTable } from "../../../_components/table/common.table";
import { toastr } from "../../../_components/toastr/toastr";
import { formFieldKeyLookupService } from "../../../_services/formFieldKeyLookup.service";
import { FormFieldKeyLookupManage } from "./formFieldKeyLookup-manage";
import { useNavigate, useParams } from "react-router-dom";


export function FormFieldKeyLookupList(params: {
}) {
    let navigate = useNavigate();
    const { formFieldKeyId } = useParams<{ formFieldKeyId: string }>();
    const _formFieldKeyId = +(formFieldKeyId || 0);

    const [data, setData] = useState<ITableData<any>>({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [isSaving, setSaving] = useState(false);

    const [filter, setFilter] = useState<IFilteringViewModel>({});

    useEffect(() => {
        if (_formFieldKeyId) fetchData();
        else setData({ items: [], count: 0 });
    }, [_formFieldKeyId]);

    function fetchData() {
        setLoading(true);
        return formFieldKeyLookupService
            .getAll(_formFieldKeyId)
            .then(
                (json) => {
                    console.log(json);
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function disable(id?: number) {
        if (!id) return;

        setSaving(true);
        return formFieldKeyLookupService
            .disable(id ?? 0)
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    fetchData();
                }
            )
            .finally(() => setSaving(false));
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'id',
                header: '#',
            },
            {
                accessorKey: 'lookupValue',
                header: 'Value',
            },
            {
                accessorKey: 'label',
                header: 'Label',
            },
            {
                accessorKey: 'hasSelectCondition',
                header: 'Has Select',
                render: (rowData: any) => <>{rowData.hasSelectCondition?.toString()}</>
            },
            {
                accessorKey: 'formFieldActionName',
                header: 'Action',
            }
        ],
        [],
    );

    return (

        <>
            <Grid container>
                <Grid item xs={12}>

                    <CommonTable
                        columns={columns}
                        data={data}
                        onEdit={(id) => { navigate("EditFormFieldKeyLookup/" + id) }}
                        filter={filter}
                        setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                        // onDelete={onDelete}
                        isLoading={isLoading}
                    />

                </Grid>
                <Grid item xs={12}>
                    <PrimaryButton
                        type="button"
                        variant="primary"
                        disabled={isLoading}
                        onClick={() => { navigate(`CreateFormFieldKeyLookup/`) }}>
                        <Icon>add</Icon> {<>Add New</>}
                    </PrimaryButton>
                </Grid>
            </Grid >
        </>

    );
}